import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import LandingPage from 'components/LandingPage/LandingPage';
import Datasets from 'components/Datasets/Datasets';
import Panels from 'components/Panels/Panels';
import SomePage from 'components/SomePage/SomePage';
import TestComponent from 'components/TestComponent/TestComponent';

const Routes = () => (
  <Switch>
    <Route exact path='/' component={LandingPage} />
    <Route exact path='/datasets' component={Datasets} />
    <Route exact path='/dataset/:tabId' component={Panels} />
    <Route exact path='/readme' component={SomePage} />
    <Route exact path='/testComponent' component={TestComponent} />
    <Redirect from='*' to='/' />
  </Switch>
);

export default Routes;
